import { Skeleton } from "antd";

import { cn } from "@btnet/utilities-core";

import { BdsText } from "@buildertrend/components";

import "./SnapshotVersionHistory.less";

import { type ISnapshotVersionHistoryProps } from "./SnapshotVersionHistory.types";
import { SnapshotVersionHistoryRow } from "./SnapshotVersionHistoryRow";

export function SnapshotVersionHistory({
    versions,
    isLoading,
    isError,
    emptyMessage = "No version history available",
    errorMessage = "Couldn't load version history. Try again.",
    selectedId,
    onVersionSelected,
    headerContent,
    testId = "snapshotVersionHistory",
    className,
}: Readonly<ISnapshotVersionHistoryProps>) {
    if (isLoading) {
        return (
            <div className={cn("SnapshotVersionHistory", className)} data-testid={testId}>
                {[1, 2, 3].map((i) => (
                    <div key={i} className="flex flex-row gap-5 px-3 py-1 items-center">
                        <div className="flex flex-col grow w-25 py-2 gap-2">
                            <Skeleton.Input active size="small" style={{ width: "80%" }} />
                            <Skeleton.Input active size="small" style={{ width: "50%" }} />
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    if (isError) {
        return (
            <div className={cn("SnapshotVersionHistory", className)} data-testid={testId}>
                <div className="flex flex-row justify-center px-4 py-2">
                    <BdsText text={errorMessage} size="distinct-md" />
                </div>
            </div>
        );
    }

    if (versions.length === 0) {
        return (
            <div className={cn("SnapshotVersionHistory", className)} data-testid={testId}>
                <div className="flex flex-row justify-center px-4 py-2">
                    <BdsText text={emptyMessage} size="distinct-md" />
                </div>
            </div>
        );
    }

    return (
        <div className={cn("SnapshotVersionHistory", className)} data-testid={testId}>
            {headerContent}
            <div className="flex flex-col">
                {versions.map((version) => (
                    <SnapshotVersionHistoryRow
                        key={version.id}
                        version={version}
                        isSelected={version.id === selectedId}
                        onSelect={(v) => onVersionSelected?.(v)}
                    />
                ))}
            </div>
        </div>
    );
}
